/* eslint-disable eqeqeq */
const removerMascara = str => {
    return str.replace(/[^A-Z0-9]/g, '');
};

const validarCpfCnpj = cpfCnpj => {
    let val = removerMascara(cpfCnpj);

    if (val.length == 11) {
        return validarCpf(val);
    } else if (val.length == 14) {
        return validarCnpj(val);
    }
};

const validarCpf = cpf => {
    let v1 = 0;
    let v2 = 0;
    let aux = false;

    for (let i = 1; cpf.length > i; i++) {
        if (cpf[i - 1] != cpf[i]) {
            aux = true;
        }
    }

    if (aux == false) {
        return false;
    }

    for (let i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
        v1 += cpf[i] * p;
    }

    v1 = (v1 * 10) % 11;

    if (v1 == 10) {
        v1 = 0;
    }

    if (v1 != cpf[9]) {
        return false;
    }

    for (let i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
        v2 += cpf[i] * p;
    }

    v2 = (v2 * 10) % 11;

    if (v2 == 10) {
        v2 = 0;
    }

    if (v2 != cpf[10]) {
        return false;
    } else {
        return true;
    }
};

const charParaValor = (char) => {
    // Se for número de 0 a 9, retorna o próprio número. Se for letra, ASCII - 48
    return /\d/.test(char) ? parseInt(char, 10) : char.charCodeAt(0) - 48;
};
const validarCnpj = cnpj => {
    if (!cnpj) return false;

    const cnpjLimpo = cnpj.toString().toUpperCase().replace(/[^A-Z0-9]/g, '');

    const regexCnpj = /^[A-Z0-9]{12}[0-9]{2}$/;
    if (!regexCnpj.test(cnpjLimpo)) return false;

    if (/^([A-Z0-9])\1+$/.test(cnpjLimpo)) return false;

    const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma1 = 0;
    for (let i = 0; i < 12; i++) {
        soma1 += charParaValor(cnpjLimpo[i]) * pesos1[i];
    }
    const resto1 = soma1 % 11;
    const dv1 = resto1 < 2 ? 0 : 11 - resto1;

    const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma2 = 0;
    for (let i = 0; i < 12; i++) {
        soma2 += charParaValor(cnpjLimpo[i]) * pesos2[i];
    }
    soma2 += dv1 * pesos2[12]; // Peso do primeiro DV
    
    const resto2 = soma2 % 11;
    const dv2 = resto2 < 2 ? 0 : 11 - resto2;

    const dvsCalculados = `${dv1}${dv2}`;
    return cnpjLimpo.endsWith(dvsCalculados);
};

export default {
    validarCpfCnpj,
    validarCpf,
    validarCnpj
};
